export default __webpack_public_path__ + "static/media/download.dbd3fd9b.png";